<template>
  <div>
    <main class="main" v-if="classData!=null && classData.length >0">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><a href="index.html">首頁</a></li>
            <li>搜尋結果</li>
          </ul>
        </div>
      </div>

      <div class="bodyContent">
        <div class="container">
          <section class="searchkeyword">
            <strong>搜尋<mark>{{this.keyWord }}</mark>結果</strong><span>共 {{this.initClassData.length}} 筆</span>
          </section>

          <section class="normalList">
              <ul class="search_style1"> <!-- 註：搜尋結果一頁最多20筆 -->
                <li v-for="(classDatas,$index) in paginationClassData" :key="classDatas.id" >
                  <div class="wrap">
                    <router-link v-bind:to="'/channel/'+classDatas.id" >
                      <div class="result">
                        <div class="hd">
                          <figure>
                            <div class="graphic"><img v-bind:src="classDatas.imgCover"></div>
                          </figure>
                          <figcaption>
                            <h3> <span v-html="markTitle(classDatas.title)"></span></h3>
                          </figcaption>
                        </div>
                        <p> <span v-html="chooseDescription($index)"></span></p>
                        <div class="subinfo row flex-space-between">
                          <div class="flex-l">
                            <div class="tutor_img"><img v-bind:src="classDatas.author.imgAvatar"></div>
                            <p>{{classDatas.author.title}}</p>
                          </div>
                          <div class="flex-r">{{classDatas.total}}集 /{{checkPoints(classDatas.products)}}</div>
                        </div>
                      </div>
                    </router-link>

                    <div class="accesslinks row flex-space-between">
                      <div class="flex-l">
                        <a v-show="isMobile" v-bind:href="'https://jinfm.page.link/?link=https://jinfm.net/channel'+classDatas.id+'&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm'" class="btnStyle_4 wIcon btn_mobile">在 App 開啟</a>
                      </div>
                      <div class="flex-r">
                        <router-link v-bind:to="'/channel/'+classDatas.id" > <a href="'/channel/'+classDatas.id" class="btnStyle_arrowright">課程介紹</a></router-link>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
          </section>

          <div class="pagiContainer">
            <v-pagination
            v-model="currentPage"
            :page-count="totalPages"
            :classes="bootstrapPaginationClasses"
            ></v-pagination>
          </div>
        </div>
      </div>
    </main>

    <main class="main"   v-if="classData!=null && classData.length ==0">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><a href="index.html">首頁</a></li>
            <li>搜尋結果</li>
          </ul>
        </div>
      </div>

      <div class="bodyContent">
        <div class="container">
          <section class="searchkeyword">
            <strong>搜尋<mark>{{this.keyWord }}</mark>結果</strong><span>共 0 筆</span>
          </section>

          <section class="emptyPage hori">
            <div class="wrap">
              <figure>
                <img src="@/assets/images/status_empty_search.png" alt="無搜尋結果">
                <figcaption>
                  <p>我們正在規劃更多的內容，敬請期待！</p>
                  <a class="btnStyle_2"  href="mailto:jinfm.hi@gmail.com">許願課程</a>
                </figcaption>
              </figure>
            </div>
          </section>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
/* eslint-disable no-undef */
import vPagination from 'vue-plain-pagination'

export default {
  components: { vPagination },

  name: 'async',
  metaInfo () {
    return {

      title: '搜尋 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '搜尋 | 一刻鯨選' },
        { property: 'og:site_name', content: '搜尋 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

      ]
    }
  },

  data () {
    return {
      keyWord: '',
      classData: null,
      initClassData: [], // 暫存初始值
      api_current_page: 1, // 抓取API頁數
      currentPage: 1, // 當前頁數
      totalPages: 2, // 總共頁數
      paginationClassData: [], // 分頁後資料
      appOpenURL: '',
      products_points: '', // 銷售方案點數

      pageUrl: '',
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      isMobile: false

    }
  },
  computed: {

  },

  watch: {
    '$route' (to, from) {
      this.$router.go(0)
    }

  },

  created () {
    this.keyWord = this.$route.query.q
    console.log(this.$store.getters.baseURL + 'channels?per_page=1000&keyword=' + this.keyWord)
    this.axios
      .get(this.$store.getters.baseURL + 'channels?per_page=1000&keyword=' + this.keyWord)
      .then(response => {
        this.api_current_page = 1
        this.classData = response.data.data
        this.initClassData = response.data.data
        this.sortClass(this.classData, 'add')
      })
      .catch(error => console.log('log:' + error))
  },

  methods: {

    checkPoints (point) {
      if (point.length === 0) {
        return '免費'
      } else {
        return point[0].points + '點'
      }
    },

    markTitle: function (title) {
      if (title.indexOf(this.keyWord) >= 0) {
        var re = new RegExp(this.keyWord, 'g')
        title = title.replace(re, '<mark>' + this.keyWord + '</mark>')
      }
      return title
    },

    chooseDescription: function (index) {
      // 如果課程簡介內容有關鍵字
      if (this.paginationClassData[index].description.indexOf(this.keyWord) >= 0) {
        var description = this.paginationClassData[index].description
        // 從關鍵字開始
        var regEx = /<[^>]*>/g
        description = description.replace(regEx, '')
        description = description.substr(description.indexOf(this.keyWord), description.length)
        // 關鍵字+mark
        var re = new RegExp(this.keyWord, 'g')
        description = description.replace(re, '<mark>' + this.keyWord + '</mark>')
        return description
      } else if (this.paginationClassData[index].author.description.indexOf(this.keyWord) >= 0) {
        // 沒有的話就抓作者的簡介
        let description = this.paginationClassData[index].author.description
        // 從關鍵字開始
        const regEx = /<[^>]*>/g
        description = description.replace(regEx, '')
        description = description.substr(description.indexOf(this.keyWord), description.length)
        // 關鍵字+mark
        const re = new RegExp(this.keyWord, 'g')
        description = description.replace(re, '<mark>' + this.keyWord + '</mark>')
        return description
      } else {
        // 都沒得就抓課程簡介
        const description = this.paginationClassData[index].description
        const regEx = /<[^>]*>/g
        return description.replace(regEx, '')
      }
    },

    // 分頁
    sortClass (classData, type) {
      if (type === 'add') {
        this.paginationClassData = []
        let i = 0
        this.allCount = classData.length
        this.totalPages = Math.ceil(classData.length / 20)

        let size = classData.length
        if (classData.length > 20) { // 最多20筆
          size = 20
        }
        for (i = 0; i < size; i++) {
          this.paginationClassData.push(classData[i])
        }
      } else { // 跳頁
        if (this.api_current_page !== this.currentPage) {
          this.paginationClassData = []
          this.allCount = classData.length

          let i = (this.currentPage - 1) * 20

          if (this.allCount > this.currentPage * 20) { // 最多20筆
            this.allCount = this.currentPage * 20
          }

          for (i; i < this.allCount; i++) {
            this.paginationClassData.push(classData[i])
          }

          this.api_current_page = this.currentPage
        }
      }
    }
  },

  updated () {
    // 判斷是否手機
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isiOS === true || isAndroid === true) {
      this.isMobile = true
    }
    this.sortClass(this.classData, 'update')
  },

  mounted () {
    $('.udnLogin').click(function () {
      $('.login').fadeIn(200).css('display', 'flex')
      $('body, .bodyWrapper').addClass('overflowhidden')
      return false
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Search.vue